module.exports = "<router-outlet><toaster-container></toaster-container></router-outlet>\n"